import { logFeature } from '@office-start/telemetry-service';
var logOdspParseError = function (itemId, error) {
    var _a;
    logFeature({
        featureName: "Recommended" /* KnownFeatureNames.Recommended */,
        eventName: "Recommended_Parse_Error" /* KnownFeatureInstrumentationEvents.RecommendedParseError */,
        params: (_a = {},
            _a["DocumentId" /* InstrumentationParam.DocumentId */] = itemId,
            _a["Error" /* InstrumentationParam.Error */] = error,
            _a),
    });
};
export var getOdspShareInfo = function (_a) {
    var isOneDriveForBusinessFile = _a.isOneDriveForBusinessFile, isSharePointFile = _a.isSharePointFile, itemId = _a.itemId, sharepointInfo = _a.sharepointInfo, url = _a.url, webUrl = _a.webUrl;
    if (!isOneDriveForBusinessFile && !isSharePointFile) {
        return {
            enabled: false,
        };
    }
    if (sharepointInfo === undefined) {
        logOdspParseError(itemId, 'item is missing sharePoint Ids');
        return {
            enabled: false,
        };
    }
    var enabled = !!sharepointInfo.siteUrl && (!!url || !!webUrl);
    if (!enabled) {
        logOdspParseError(itemId, 'Sharing disabled for item. siteUrl or URLs are missing');
    }
    return {
        enabled: enabled,
        type: 'Commercial',
        sharePointIds: sharepointInfo,
        url: url !== null && url !== void 0 ? url : webUrl,
    };
};
//# sourceMappingURL=odspShareUtilities.js.map